'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Notification = require('utils/notification');
var SmartTemp = require('models/smart_temp');

var DataView = AbstractTableView.extend({
    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click div.js-edit-value': 'editValue',
        });
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: ['.js-edit-value'],

            getDeviceID: function (view) {
                return view.device.id;
            },
        },
    },

    initialize: function (options) {
        // request all devices if not already cached
        var self = this;
        this.device = options.device;
        this.controller = options.controller;
        options.smartTempInfo = options.smartTempInfo || new SmartTemp.SmartTempInfo();
        this.inconsistent = [];
        this.smartTemp = options.smartTempInfo;
        this.smartTempRegisters = options.smartTempInfo
            ? this.options.smartTempInfo.getOptimizedRegisters()
            : undefined;
        if (options.inconsistent) {
            this.inconsistent = options.inconsistent.data_points || [];
        }

        // determine link to admin view (might be shown as footnote)
        this.adminLink = Consts.DeviceCategory[options.category].url + '/' + options.device.id + '/admin-configuration';
        // prepare collection ..
        _.each(this.collection.models, function (m) {
            // .. translate data point name
            m.set('name', i18n.DATAPOINT(options.device.get('category'), m.get('name')));
            // .. inject device data into all collection models
            m.set('data', options.device.get('data'));
            // .. determine value consistency
            var valueID = m.get('type') + '_' + m.get('nr');
            var isInconsistent = !m.get('is_readonly') && _.contains(self.inconsistent, valueID);
            m.set('isInconsistent', isInconsistent);
            m.set('highlighted', isInconsistent);
            m.set('smartTemp', self.smartTemp && _.contains(self.smartTempRegisters, m.getAddress()));
            m.set(
                'isDryRun',
                self.smartTemp &&
                    _.contains(self.smartTempRegisters, m.getAddress()) &&
                    self.smartTemp.find(function (model) {
                        return model.get('dummy_values') && model.get('register_to_optimize') === m.getAddress();
                    })
            );
        });

        AbstractTableView.prototype.initialize.apply(this, [
            {
                title: i18n.TR('Daten'),
                columns: [
                    { id: '#_name_text', name: 'Name', alwaysVisible: true }, // i18n.TR('Name')
                    { id: '#_value', name: 'Wert' }, // i18n.TR('Wert')
                ],
                hasRefreshButton: true,
                hasSelectionButtons: false,
                headingID: 'data',
            },
        ]);
        if (this.smartTemp) {
            this.options.warnings = this.smartTemp.getWarnings();
        }
    },

    setPermission: function (permissions) {
        var hasFullAccess = !permissions.get(Consts.Permissions.StateData);
        var canConfigure = permissions.get(Consts.Permissions.AdminConfig) === false;

        if (hasFullAccess && !this.device.isWritingDisabled()) {
            // mark editable models
            _.each(this.collection.models, function (m) {
                m.set('isEditable', !m.get('is_readonly'));
            });

            if (canConfigure) {
                // -> show footnote with link to configuration tab
                this.options.footNote =
                    i18n.TR('Wertekonfiguration') +
                    ': <a id="h-value-config" href="' +
                    this.adminLink +
                    '">' +
                    i18n.TR('Verwaltung > Konfiguration') +
                    '</a>';
            }
        }
    },

    filter: function (child, index, collection) {
        // do not show elements with length > 10, e.g. time programs
        if (child.get('length') > 10 && child.get('format') != 'ascii') {
            return false;
        }

        // do not show protected elements to regular users
        return !child.get('is_protected') || AppState.user.get('is_admin');
    },

    refreshTable: function (e) {
        var url = Backbone.history.fragment;
        /*
		TODO: Currently, do _not_ update meter bus values when refreshing the
			  table. The behavior should be consistent across all device
			  categories.

		if (this.device && this.device.get('category') == Consts.Category.Meter) {
			Decorator.displayLoading(true);
			var req = App.request('device:values:refresh', this.device.id)
			$.when(req).done(function() {
				Backbone.history.loadUrl(url);
				Decorator.displayLoading(false);
			});
			return;
		}
*/
        // reload current route
        Backbone.history.loadUrl(url);
    },

    editValue: function (e) {
        e.preventDefault();

        var model = this.collection.get(e.currentTarget.id.substring(8));
        if (model === undefined) {
            Notification.show(
                'warning',
                i18n.TR('Warnung'),
                i18n.TR('Vorangegangener Schreibbefehl wird verarbeitet.')
            );
            this.refreshTable();
            return;
        }

        var self = this;
        this.checkEdit(model, self.device, function (writeInfo) {
            if (self.smartTemp && self.smartTempRegisters.includes(model.getAddress())) {
                var smartTempModel = self.smartTemp.getActiveModels().find(function (m) {
                    return m.get('register_to_optimize') === model.getAddress();
                });
                self.controller.showSmartTempDialog({
                    smartTempInfo: self.smartTemp,
                    controllerID: smartTempModel.get('controller_id'),
                    meterID: smartTempModel.get('meter_id'),
                    callback: function () {
                        self.smartTemp = undefined; // just delete this after successfull deactivation
                        self.optimizedRegister = undefined;
                    },
                });
            } else {
                self.controller.showEditValueDialog(model, self.device, writeInfo);
            }
        });
    },

    checkEdit: function (model, device, fct) {
        // check if it is possible to edit this value
        App.request('device:values:write-info', device.id, model.get('nr')).done(function (result) {
            if (!result) {
                Notification.show(
                    'warning',
                    i18n.TR('Warnung'),
                    i18n.TR('Schreibbefehl kann nicht ausgeführt werden.')
                );
                return;
            }
            fct(result);
        });
    },
});

module.exports = DataView;
